import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { useLang } from "@/i18n";

const ease = [0.16, 1, 0.3, 1];

export default function CompetitionGroups() {
  const { t } = useLang();
  const c = t.competition;

  return (
    <section id="competicion" className="px-5 py-24 sm:px-8 sm:py-32">
      <div className="mx-auto max-w-7xl">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          className="mb-4 flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-[0.3em] text-accent"
        >
          <Trophy size={13} /> {c.label}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, ease }}
          className="relative overflow-hidden rounded-2xl border border-white/10 bg-card"
          data-testid="competition-section"
        >
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative min-h-[300px] lg:min-h-[440px]">
              <img src="/photos/tlp_4.webp" alt={c.photoAlt} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
              <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(270deg,#14141A_0%,transparent_45%),linear-gradient(0deg,rgba(8,8,10,0.5)_0%,transparent_45%)] lg:bg-[linear-gradient(90deg,transparent_55%,#14141A_100%),linear-gradient(0deg,rgba(8,8,10,0.5)_0%,transparent_45%)]" />
              <span className="absolute left-4 top-4 flex items-center gap-1.5 rounded-full bg-accent px-3.5 py-1.5 font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-white shadow-[0_0_20px_rgba(255,0,122,0.5)]">
                <Trophy size={12} /> K-HOUSE CREW
              </span>
            </div>

            <div className="flex flex-col justify-center gap-5 p-7 sm:p-10">
              <h2 className="font-display text-2xl font-extrabold uppercase tracking-tight sm:text-4xl">{c.title}</h2>
              <p className="max-w-lg text-sm leading-relaxed text-zinc-300 sm:text-base">{c.desc}</p>
              <div className="flex flex-wrap gap-2">
                {c.chips.map((chip) => (
                  <span key={chip} className="rounded-full border border-accent/50 bg-accent/10 px-3.5 py-1.5 font-mono text-[11px] font-bold uppercase tracking-[0.15em] text-accent">
                    {chip}
                  </span>
                ))}
              </div>
              <div className="mt-2 grid grid-cols-2 gap-3 sm:grid-cols-3">
                {["/photos/tlp_5.webp", "/photos/tlp_2.webp", "/photos/tlp_1.webp"].map((src) => (
                  <img key={src} src={src} alt="K-HOUSE · escenario TLP" loading="lazy" className="h-20 w-full rounded-lg border border-white/10 object-cover sm:h-24" />
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}